"use client";

import { create } from "zustand";
import type {
  LocationT,
  MakeT,
  ServiceT,
} from "@/app/(pages)/(frontend)/t/[tenant]/finanzdienstleistungen/constants/financial-service-links";
import {
  DEFAULT_FUNNEL_STEP,
  type FunnelStepIdT,
} from "@/app/(pages)/(frontend)/t/[tenant]/finanzdienstleistungen/constants/funnel-data";

type FinancialServiceFunnelStateT = {
  // State
  currentStep: FunnelStepIdT;
  selectedLocation: LocationT | null;
  selectedMake: MakeT | null;
  selectedService: ServiceT | null;

  // Actions
  startFunnel: () => void;
  selectLocation: (location: LocationT) => void;
  selectMake: (make: MakeT) => void;
  selectService: (service: ServiceT) => void;
  goBack: () => void;
  reset: () => void;
};

export const useFinancialServiceFunnelStore =
  create<FinancialServiceFunnelStateT>((set, get) => ({
    // Initial state
    currentStep: DEFAULT_FUNNEL_STEP,
    selectedLocation: null,
    selectedMake: null,
    selectedService: null,

    // Actions
    startFunnel: () => {
      set({ currentStep: "location" });
    },

    selectLocation: (location) => {
      set({
        selectedLocation: location,
        currentStep: "make",
        selectedMake: null,
        selectedService: null,
      });
    },

    selectMake: (make) => {
      set({
        selectedMake: make,
        currentStep: "service",
        selectedService: null,
      });
    },

    selectService: (service) => {
      set({
        selectedService: service,
      });
    },

    goBack: () => {
      const { currentStep } = get();
      if (currentStep === "intro") {
        return;
      }

      if (currentStep === "location") {
        set({
          currentStep: DEFAULT_FUNNEL_STEP,
          selectedLocation: null,
          selectedMake: null,
          selectedService: null,
        });
        return;
      }

      if (currentStep === "make") {
        set({
          currentStep: "location",
          selectedMake: null,
          selectedService: null,
        });
        return;
      }

      if (currentStep === "service") {
        set({
          currentStep: "make",
          selectedService: null,
        });
      }
    },

    reset: () => {
      set({
        currentStep: DEFAULT_FUNNEL_STEP,
        selectedLocation: null,
        selectedMake: null,
        selectedService: null,
      });
    },
  }));
